export const validateCharacter = {
    japaneseKanji(str) {
        str = str || ' '
        const regex = /[\u4E00-\u9FAF]|\u203B/g;
        const rs = str.match(regex);
        return !rs ? false : rs.length === str.length
    },
    japaneseKana(str) {
        str = str || ' '
        const regex = /[\u30A0-\u30FF\s]|\u203B/g;
        const rs = str.match(regex);
        return !rs ? false : rs.length === str.length
    },
    japaneseKanaKanji(str) {
        str = str || ' '
        const regex = /[\u3040-\u309F]|[\u4E00-\u9FAF]|[\u30A0-\u30FF]|\u203B/g;
        const rs = str.match(regex);
        return !rs ? false : rs.length === str.length
    },
    japaneseRegex(str = ' ') {
        const regex = /[0-9]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[!@#$%^&*(),.?":{}|<>-]|\s|\u203B/g;
        const rs = str.match(regex);
        return !rs ? false : rs.length === str.length
    },
    number1Byte(num) {
        const regex = /^\d+$/;
        return regex.test(num);
    },
    phoneNumberRegex(num) {
        const regex = /^([\d|-]+)$/;
        return regex.test(num);
    },
    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;  // eslint-disable-line
        return re.test(String(email).toLowerCase()) && this.checkChar1Byte(email);
    },
    checkZipCodeJapanese(num = ' ') {
        const re = /^\b\d{3}[-]\d{4}\b/g;
        return re.test(num) && num.length === 8
    },
    checkChar2Byte(str) {
        return [...str].filter(s => (encodeURI(s).split(/%..|./).length - 1) === 2).length === str.length;
    },
    checkChar1Byte(str) {
        return [...str].filter(s => (encodeURI(s).split(/%..|./).length - 1) === 1).length === str.length;
    }
};
